export interface DetailParams extends Record<string, string> {
  id: string;
}

export const InternalDataSourceProviders = new Set(["queues", "pipelines"]);
